enum RelatedTasksMode {
  ContributingTasks = 'contributing_tasks',
  ContributingEpics = 'contributing_epics',
  ContributingTeams = 'contributing_teams',
}

export { RelatedTasksMode };
